import { action } from 'easy-peasy';
import { IResetCurrentLocationGroupAction } from '../types';

const resetCurrentLocationGroup: IResetCurrentLocationGroupAction = action(state => {
  state.current = null;
});

export default resetCurrentLocationGroup;
